import React from 'react'
import MaterialSymbol from '../material-symbol'

const AccessibleForward = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="accessible_forward" {...props} />
))

AccessibleForward.displayName = 'AccessibleForward'

export default AccessibleForward
